(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mars3d-cesium"), require("mars3d"));
	else if(typeof define === 'function' && define.amd)
		define("mars3dTdt", ["mars3d-cesium", "mars3d"], factory);
	else if(typeof exports === 'object')
		exports["mars3dTdt"] = factory(require("mars3d-cesium"), require("mars3d"));
	else
		root["mars3dTdt"] = factory(root["Cesium"], root["mars3d"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 